import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  setItem(key: string, data: string): void {
    localStorage.setItem(key, JSON.stringify(data));
  }

  getItem(key: string): string | JSON | null {
    return JSON.parse(localStorage.getItem(key)) || null;
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  clear(): void {
    localStorage.clear();
  }
}
